import { usePostHog } from "posthog-js/react"
import { POSTHOG_FEATURES } from "../constants/feature-flags"
import { useAuthControllerCurrentUserQuery } from "../api/authApi"

interface SystemNotificationResult {
  enabled: boolean
  payload?: unknown
}

/**
 * Custom hook for system notification feature flag
 *
 * This hook returns both the enabled state and payload for system notifications
 *
 * @returns SystemNotificationResult - object with enabled boolean and payload value
 */
export const useSystemNotification = (): SystemNotificationResult => {
  const posthog = usePostHog()
  const { data: currentUser } = useAuthControllerCurrentUserQuery()

  const payload = posthog?.getFeatureFlagPayload(
    POSTHOG_FEATURES.SYSTEM_NOTIFICATION_BY_COMPANY,
  )

  if (
    (payload as Record<string, unknown>)?.override_for_super_admin &&
    currentUser?.user.isSuperAdmin
  ) {
    return {
      enabled: false,
    }
  }

  const enabled =
    posthog?.isFeatureEnabled(
      POSTHOG_FEATURES.SYSTEM_NOTIFICATION_BY_COMPANY,
    ) ?? false

  // if (payload?.override_by_user) {
  //   return {
  //     enabled: false,
  //   }
  // }

  return {
    enabled,
    payload,
  }
}

export default useSystemNotification
